import useAppQuery from 'hooks/useAppQuery';
import useAppUser from 'hooks/useAppUser';
import API from 'services/API';
import {
  AgencyDnsSettingStatus,
  GetAgencyDnsSettingsResponse,
} from 'models/CustomDomains';

export const AGENCY_DNS_SETTINGS_BASE_QUERY_KEY = 'agency-dns-settings';

const useFetchAgencyDnsSettings = () => {
  const { agencyUid } = useAppUser();
  const {
    data: dnsSettings,
    isInitialLoading,
    isFetching,
    isError,
    refetch,
  } = useAppQuery(
    [AGENCY_DNS_SETTINGS_BASE_QUERY_KEY, agencyUid],
    async () => {
      const response = await API.get<GetAgencyDnsSettingsResponse>(
        `api/internal/agencies/${agencyUid}/dns-settings`,
      );

      // a setting being deleted is on its way out; treat it as gone
      return (response.data.applicationSettings ?? []).filter(
        ({ status }) => status !== AgencyDnsSettingStatus.PENDING_DELETION,
      );
    },
    {
      enabled: !!agencyUid,
    },
  );

  return {
    dnsSettings: dnsSettings ?? [],
    isLoading: isInitialLoading,
    isFetching,
    isError,
    refetch,
  };
};

export default useFetchAgencyDnsSettings;
